import { isGermanLocale } from '../services/metrics-calculations.service';
import { isObject } from './object.utilities';

export function valueToCamelCase(value: any): any {
  return Array.isArray(value) ? arraySnakeToCamelCase(value) : isObject(value) ? objectSnakeToCamelCase(value) : value;
}

export function valueToSnake(value: any): any {
  return Array.isArray(value) ? arrayCamelCaseToSnake(value) : isObject(value) ? objectCamelCaseToSnake(value) : value;
}

export function arraySnakeToCamelCase<T>(arr: any[]): T[] {
  return Array.isArray(arr) ? arr.map((obj) => valueToCamelCase(obj)) : [];
}

export function arrayCamelCaseToSnake<T>(arr: any[]): T[] {
  return Array.isArray(arr) ? arr.map((obj) => valueToSnake(obj)) : [];
}

export function objectSnakeToCamelCase<T>(obj: object): T {
  if (!obj) return <T>obj;
  return Object.entries(obj).reduce(
    (camelObj, [key, value]) => ({
      ...camelObj,
      [snakeToCamelCase(key)]: valueToCamelCase(value),
    }),
    {} as T,
  );
}

export function WrapInParenthesis(value) {
  return value ? `(${value})` : '';
}

export function objectCamelCaseToSnake<T>(obj: object): T {
  return Object.entries(obj).reduce(
    (camelObj, [key, value]) => ({
      ...camelObj,
      [camelToSnake(key)]: valueToSnake(value),
    }),
    {} as T,
  );
}

export function snakeToCamelCase<T>(snake: string): string {
  // user_profile_image_url => userProfileImageUrl
  // supports numbers
  return snake?.toLowerCase().replace(/_([a-z0-9])/g, (_, k) => k.toUpperCase());
}

export function camelToSnake(camel: string): string {
  //userProfileImageUrl => user_profile_image_url
  // supports numbers
  return camel
    .split(/(?=[A-Z])|(?<=[a-z])(?=\d)|(?<=\d)(?=[a-z])/)
    .join('_')
    .toLowerCase();
}

export function trimValue<T>(value: T): T {
  return (
    Array.isArray(value)
      ? trimArray(value)
      : isObject(value)
        ? trimObject(value)
        : typeof value === 'string'
          ? value.trim()
          : value
  ) as T;
}

export function trimArray<T>(value: T[]): T[] {
  return value.map((item) => trimValue(item));
}

export function trimObject<T extends object>(value: T): T {
  return Object.keys(value).reduce((obj, key) => ({ ...obj, [key]: trimValue(value[key]) }), {} as T);
}

export function search(source: unknown, searchTerm: string): boolean {
  return source?.toString().toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase());
}

export function searchInProperties<T extends object>(source: T, properties: (keyof T)[], searchTerm: string): boolean {
  return properties.some((prop) => search(source[prop], searchTerm));
}

export function ucFirst(str: string): string {
  return str?.charAt(0).toUpperCase() + str?.slice(1) || '';
}

export function StringifyArray(...args): string {
  return args.map((d) => JSON.stringify(d)).join('^^');
}

export function simpleSanitze(str): string {
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export function multiReplace(str: string, keys: [string, any][]): string {
  return keys.reduce((acc, [key, value]) => acc.replace(key, value), str || '');
}

export const Capitalize = (s) => s && s[0]?.toUpperCase() + s.slice(1)?.toLowerCase();

export const SplitHyphensAndCapitalize = (s) => {
  return s
    ?.split('-')
    .map((e) => Capitalize(e))
    .join(' ');
};

export const isValidLocalizedNumber = (value) =>
  (isGermanLocale() ? /^-?(0|[1-9][0-9]*)(\,[0-9]*)?$/ : /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/).test(value);
